export enum ProductType {
  BACK_ORDER_PRODUCT = '2',
}
